var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronDownIcon = function SvgChevronDownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3 5.187c.359-.28.9-.242 1.208.085L8 10.027l4.492-4.755a.919.919 0 0 1 1.209-.085c.36.28.4.77.093 1.097L8.65 11.728A.896.896 0 0 1 8 12c-.25 0-.488-.1-.65-.272L2.205 6.284A.729.729 0 0 1 2.3 5.187Z",
    fill: "currentColor"
  })));
};

export default SvgChevronDownIcon;